import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Firmar } from '../models/firmar';
import { DataService } from '../_services/data.service';
import { MatriculacionService } from '../_services/matriculacion.service';
import { ProfesionalesService } from '../_services/profesionales.service';

@Component({
  selector: 'app-info-firmas',
  templateUrl: './info-firmas.component.html',
  styleUrls: ['./info-firmas.component.scss']
})
export class InfoFirmasComponent implements OnInit {
  datosMatricula: any;
  formFirmar!: FormGroup;
  validadones!: Boolean;
  errorFirma!: Boolean;
  cargando!: Boolean;
  listaProfesionales: any;
  errorString!:string;
  constructor(private dataService: DataService,
    private matriculaService: MatriculacionService,
    private profesionalesService: ProfesionalesService,
    private formBuilder: FormBuilder,
    public appComponent: AppComponent,
    private router: Router,) {
  }

  public datosFirma: any;
  get formulario(): { [key: string]: AbstractControl } {
    return this.formFirmar.controls;
  }
  ngOnInit(): void {
    this.datosMatricula = this.dataService.datosMatricula;
    this.listaProfesionales = this.profesionalesService.obtener().subscribe(result => {
      this.listaProfesionales = result;
    }, (error) => {

    });
    if (this.datosMatricula === undefined || this.datosMatricula === null) {
      this.router.navigate(['/home']);
    }
    this.formFirmar = this.formBuilder.group(
      {
        matricula: [null, Validators.required],
        expediente: [null, Validators.required],
        fechaExpedicion: [null, Validators.required],
        fechaMatriculacion: [null, Validators.required],
        profesion: [null, Validators.required],
        pais: [this.datosMatricula.domicilio.pais, Validators.required],
        provincia: [this.datosMatricula.domicilio.provincia, Validators.required],
        ciudad: [this.datosMatricula.domicilio.ciudad, Validators.required],
        cpostal: [this.datosMatricula.domicilio.cpostal, Validators.required],
        municipio: [this.datosMatricula.domicilio.municipio, Validators.required],
        calle: [this.datosMatricula.domicilio.calle, Validators.required],
        numero: [this.datosMatricula.domicilio.numero, Validators.required],
        barrio: [this.datosMatricula.domicilio.barrio, Validators.required],
        monoblock: [this.datosMatricula.domicilio.monoblock, null],
        piso: [this.datosMatricula.domicilio.piso, null],
        departamento: [this.datosMatricula.domicilio.departamento, null],
      }
    );
    this.recorrerDocumentacion();
  }
  documentacion: any = [];
  recorrerDocumentacion() {
    this.documentacion = [];
    let datos: any = {};
    this.datosMatricula.titulos.forEach((el: { documentacion: {}; titulo_descripcion: any; }) => {
      let datos: any = {};
      datos.documentacion = el.documentacion;
      datos.titulo = el.titulo_descripcion;
      this.documentacion.push(datos);
    });
  }

  onSubmit() {
    this.validadones = true;
    if (this.formFirmar.valid) {
      this.firmar();
    }
  }

  firmar() {
    let formObj = this.formFirmar.getRawValue();
    let firma = new Firmar;
    this.cargando = true;
    this.errorFirma = false;
    if (this.appComponent.usuarioLogueado) {
      firma.id_usuario = this.appComponent.usuarioLogueado?.idUsuario;
      firma.matricula = formObj.matricula;
      firma.id_proceso = this.datosMatricula.id_proceso;
      firma.expediente = formObj.expediente;
      firma.id_profesion = formObj.profesion;
      firma.fecha_expedicion = formObj.fechaExpedicion;
      firma.fecha_matriculacion=formObj.fechaMatriculacion;
    }
    this.matriculaService.iniciarFirma(firma).subscribe(result => {
      window.location.href = result.url;
    }, (error) => {
      this.errorString=error;
      this.cargando = false;
      this.errorFirma = true;
    });
  }

}
